import script from "./HolidayItem.vue?vue&type=script&setup=true&lang=js"
export * from "./HolidayItem.vue?vue&type=script&setup=true&lang=js"

import "./HolidayItem.vue?vue&type=style&index=0&id=4cc35cf1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cc35cf1"]])

export default __exports__